export default "__VITE_ASSET__C4gK7b9U__"